import { message } from 'antd';
import { Button, ContentFilters, ContentTopBar } from 'components';
import { RatingApiService } from 'features/rating/api/rating-api.service';
import { RatingFilterForm } from 'features/rating/components/rating-filter-form/rating-filter-form';
import {
  RatingFilterFormPaginated,
  RatingFilterFormValues,
} from 'features/rating/components/rating-filter-form/type';
import { RatingViewTable } from 'features/rating/components/rating-table/rating-view-table-data';
import { useGetRatingList } from 'features/rating/use-cases/get-rating-list';
import { usePaginationParams } from 'hooks';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
const initialFilterValues: RatingFilterFormValues = {
  FacilityId: undefined,
};
// ../components/rating-filter-form/type
export const RatingListView = () => {
  const { params, updateParams, resetPage } =
    usePaginationParams<RatingFilterFormPaginated>({
      page: 1,
      size: 10,
      ...initialFilterValues,
    });

  const [facilityId, setFacilityId] = useState<RatingFilterFormValues>({
    FacilityId: undefined,
  });

  const { data, isFetching } = useGetRatingList(params, { retry: false });

  const handleFiltersChange = (values: RatingFilterFormValues) => {
    setFacilityId(values);
    updateParams(values);
    resetPage();
  };
  const exportData = async () => {
    try {
      const facilityParam =
        facilityId?.FacilityId || '00000000-0000-0000-0000-000000000000';
      const res = await RatingApiService().getRatingReport(facilityParam);
      const blob = new Blob([res.data as any], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const contentDisposition = res.headers?.['content-disposition'];
      const match = contentDisposition?.match(/filename="?([^"]+)"?/);
      const filename = match?.[1] || 'rating-report.xlsx';

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      message.error(error);
    }
  };
  const formId = 'rating-filter-form';

  return (
    <>
      <ContentTopBar
        title={'Rating List'}
        renderButtons={
          <>
            <Button onClick={exportData}>Export</Button>
          </>
        }
      />
      <ContentFilters formId={formId}>
        <RatingFilterForm
          formId={formId}
          handleFilter={handleFiltersChange}
          initialValues={initialFilterValues}
        />
      </ContentFilters>
      <RatingViewTable
        isLoading={isFetching}
        data={data}
        tableParams={params}
        updateParams={updateParams}
      />

      <Outlet />
    </>
  );
};
